var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64645 2.14645C7.84171 1.95118 8.15829 1.95118 8.35355 2.14645L13.8536 7.64645C14.0488 7.84171 14.0488 8.15829 13.8536 8.35355C13.6583 8.54882 13.3417 8.54882 13.1464 8.35355L8.5 3.70711V13H13.5C13.7761 13 14 13.2239 14 13.5C14 13.7761 13.7761 14 13.5 14H2.5C2.22386 14 2 13.7761 2 13.5C2 13.2239 2.22386 13 2.5 13H7.5V3.70711L2.85355 8.35355C2.65829 8.54882 2.34171 8.54882 2.14645 8.35355C1.95118 8.15829 1.95118 7.84171 2.14645 7.64645L7.64645 2.14645Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.002f2891c29b339e74ce8ccdb010e9f4.svg";
export { ForwardRef as ReactComponent };